import { render, staticRenderFns } from "./Markers.vue?vue&type=template&id=2073a867"
import script from "./Markers.vue?vue&type=script&lang=js"
export * from "./Markers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports